// extracted by mini-css-extract-plugin
export default {"infoBar":"InfoBar_infoBar__Izi+x","titleContent":"InfoBar_titleContent__6iCCX","icon":"InfoBar_icon__d92e6","values":"InfoBar_values__Kzhyc"};